/**
 * Pure form helpers for the client "propose an idea" modal. Kept out of
 * the component so the submit payload and the submit-gating are unit
 * testable (this repo has no @testing-library/react for render tests).
 */

import type { CreateClientIdeaInput } from "../services/clientIdeasService";

/**
 * Build the request payload from the raw field values. Title is trimmed;
 * description and link are trimmed and dropped when blank so the API gets
 * `undefined` rather than empty strings.
 */
export function buildCreateClientIdeaInput(
  title: string,
  description: string,
  link: string,
): CreateClientIdeaInput {
  const input: CreateClientIdeaInput = { title: title.trim() };
  const trimmedDescription = description.trim();
  const trimmedLink = link.trim();
  if (trimmedDescription) input.description = trimmedDescription;
  if (trimmedLink) input.link = trimmedLink;
  return input;
}

/** Submit is allowed only with a non-blank title and no request in flight. */
export function canSubmitIdea(title: string, isSubmitting: boolean): boolean {
  return title.trim().length > 0 && !isSubmitting;
}
